import { persistentReducedStream, reducer } from '@ardoq/rxbeach';
import {
  endTour,
  nextTourStep,
  prevTourStep,
  startTour,
  startTourAtStep,
  type StartTourAtStepPayload,
} from './actions';
import type { TourId } from '@ardoq/product-tours';
import { resetState } from '@ardoq/common-helpers';

/**
 * Discriminated union so an inactive tour cannot carry a step index — avoids
 * "impossible states" per the RxBeach guidelines.
 */
export type TourState =
  | { isActive: false }
  | { isActive: true; tourId: TourId; stepIndex: number };

const defaultState: TourState = { isActive: false };

const setTourIdAndStarTour = (
  _state: TourState,
  tourId: TourId
): TourState => ({
  isActive: true,
  tourId,
  stepIndex: 0,
});

const setTourIdAndStep = (
  _state: TourState,
  { tourId, stepIndex }: StartTourAtStepPayload
): TourState => ({
  isActive: true,
  tourId,
  stepIndex: Math.max(0, stepIndex),
});

const nextStep = (state: TourState): TourState =>
  state.isActive ? { ...state, stepIndex: state.stepIndex + 1 } : state;

const prevStep = (state: TourState): TourState =>
  state.isActive
    ? { ...state, stepIndex: Math.max(0, state.stepIndex - 1) }
    : state;

export const productTourStatus$ = persistentReducedStream<TourState>(
  'productTourStatus$',
  defaultState,
  [
    reducer(startTour, setTourIdAndStarTour),
    reducer(startTourAtStep, setTourIdAndStep),
    reducer(nextTourStep, nextStep),
    reducer(prevTourStep, prevStep),
    reducer(endTour, resetState(defaultState)),
  ]
);
